import api from '@/apis/lg/lgLedgerOriginalAPI';
import Crud from '@/stores/crudBase.js';
var crud = new Crud('lgLedgerOriginal', api);

const state = {
  ...crud.state,
  _config: {
    table: 'lg_original_ledger',
    field: {
      key: 'lg_original_ledger_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Load danh sách chứng từ cùng loại (override lại để chỉnh lại API)
   */
  async loadVoucherByType(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.getVoucherByType(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }
    
    context.commit('updatePayloadNextBack', {...payload});
    if (res && !payload.isNextBack) {
      context.commit('setPaging', res);
    }

    return res;
  },
  /**
   * Đếm danh sách chứng từ cùng loại (override lại để chỉnh lại API)
   */
  async loadSummaryVoucherByType(context, payload) {
    let res = null;
    try {
      context.commit('updateLoadingSummary', true);
      res = await api.getVoucherByType(payload || {});
    } finally {
      context.commit('updateLoadingSummary', false);
    }

    if (res) {
      context.commit('setPaging', res);
      context.commit('setPayload', payload);
    }

    return res;
  },

};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
